import { useEffect, useState } from 'react'
import { Modal, Box, IconButton, useTheme, useMediaQuery } from '@mui/material'
import Carousel from 'react-material-ui-carousel'
import CloseIcon from '@mui/icons-material/Close'
import { IMedia } from 'src/types'
import { MediaModal } from '../media-modal'

interface IProps {
  open: boolean
  handleClose: () => void
  images: Pick<IMedia, 'link' | 'link_medium' | 'title' | 'id'>[]
  startIndex: number
}

const ImageGalleryModal = ({ open, handleClose, images, startIndex = 0 }: IProps) => {
  const [currentIndex, setCurrentIndex] = useState(startIndex)

  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))

  const handleCarouselChange = (index: number) => {
    setCurrentIndex(index)
  }

  useEffect(() => {
    setCurrentIndex(startIndex)
  }, [startIndex])

  return (
    <MediaModal
      ariaLabel="modal-image"
      open={open}
      handleClose={handleClose}
      closeOnParentClick
      showCloseButton
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        onClick={(e) => {
          e.stopPropagation()
        }}
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          maxWidth: 800,
          outline: 'none',
        }}
      >
        <Carousel
          index={currentIndex}
          autoPlay={false}
          animation="slide"
          indicators={false}
          navButtonsAlwaysVisible={!isTablet}
          onChange={(now) => {
            if (typeof now === 'number') {
              handleCarouselChange(now)
            }
          }}
        >
          {images.map((image, idx) => (
            <Box
              onClick={(e) => {
                e.stopPropagation()
              }}
              key={image.id || idx}
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',

                height: '90dvh',
              }}
            >
              <img
                onClick={(e) => {
                  e.stopPropagation()
                }}
                src={image.link}
                alt={image.title || `Image ${idx + 1}`}
                style={{
                  maxWidth: '100%',
                  maxHeight: '100%',
                  pointerEvents: 'none',
                  objectFit: 'cover',
                }}
              />
            </Box>
          ))}
        </Carousel>
      </Box>
    </MediaModal>
  )
}

export default ImageGalleryModal
